<i [class]="[itemHealth?.Icon(component), itemHealth?.Foreground(component)]"></i>